<template>
  <div :class="['threedimension', {isscroly: slideIndex !== undefined}]">
    <canvas touch-action="none"></canvas>
    <st-loading v-if="showLoading" :themecolor="slideIndex === undefined ? '' : 'darkcolor'"/>
    <!-- <div>
      <span @click="rotateLeft"> < </span>
      <span @click="rotateRight"> > </span>
      <span @click="zoomIn()"> + </span>
      <span @click="zoomOut()"> - </span>
      <span @click="xrCamera">AR</span>
    </div> -->
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import {Scene, Engine, Vector3, Color4, SceneLoader, ArcRotateCamera, HemisphericLight, Color3, Animation} from 'babylonjs'
import StLoading from '../../../StLoading.vue'
import {hotSpotActions, rotateLeft, rotateRight, zoomIn, zoomOut, xrCamera} from './3DActions.js'

export default {
  props: ['slideIndex', 'slideProgress', 'attributes'],
  components: {StLoading},
  data () {
    return {
      canvas: null, // Get the canvas element
      engine: null, // Generate the BABYLON 3D engine
      scene: null,
      camera: null,
      mesh: null,
      initRotateAnimation: null,
      originalScale: 1,
      scaleRatio: 0.8,
      originalPosition: {x: 0, y: 0, z: 0},
      positionYMult: 18,
      radius: 20,
      slideAnimationFrames: 100,
      frameRanges: {from: 0, to: 0},
      meshAnimationsArr: [],
      camAnimationsArr: [],
      currentSlideIndex: 0,
      showLoading: true
    }
  },
  mounted () {
    const self = this
    window.addEventListener('resize', debounce(function () {
      self.resizeDevice()
      if (self.engine) {
        self.engine.resize()
      }
    }, 100))
    this.resizeDevice()
    this.init3D()
    window.onblur = function () {
      if (self.scene) {
        self.scene.stopAllAnimations()
      }
      if (self.mesh) {
        self.mesh.setEnabled(false)
      }
      if (self.camera) {
        self.camera.setEnabled(false)
      }
    }
    window.onfocus = function () {
      if (self.mesh) {
        self.mesh.setEnabled(true)
      }
      if (self.camera) {
        self.camera.setEnabled(true)
      }
    }
  },
  beforeDestroy () {
    if (this.mesh) {
      this.mesh.setEnabled(false)
    }
    if (this.camera) {
      this.camera.setEnabled(false)
    }
    if (this.scene) {
      this.scene.stopAllAnimations()
      this.scene.dispose()
    }
  },
  watch: {
    slideProgress: function (newVal, oldVal) {
      if (this.mesh && this.camera && newVal) {
        this.scene.stopAllAnimations()
        const frames = this.slideIndex * this.slideAnimationFrames
        // var maxFrame = this.attributes.value.length * this.slideAnimationFrames
        var start = (oldVal || 0) * this.slideAnimationFrames + frames
        var end = newVal * this.slideAnimationFrames + frames
        if (this.currentSlideIndex !== this.slideIndex) {
          if (this.currentSlideIndex < this.slideIndex) {
            start -= this.slideAnimationFrames
          } else {
            start += this.slideAnimationFrames
          }
          this.currentSlideIndex = this.slideIndex
        }
        start = Math.round(start)
        end = Math.round(end)
        if (start > this.frameRanges.to) {
          start = this.frameRanges.to - 1
        }
        if (end > this.frameRanges.to) {
          end = this.frameRanges.to - 1
        }
        // if (start <= this.frameRanges.from + 0.5) {
        //   start = this.frameRanges.from + 0.5
        // }
        if (end < this.frameRanges.from + 0.1) {
          end = this.frameRanges.from + 0.1
        }
        this.scene.beginDirectAnimation(this.camera, this.camAnimationsArr, start, end)
        this.scene.beginDirectAnimation(this.mesh, this.meshAnimationsArr, start, end)
      }
    }
  },
  methods: {
    resizeDevice () {
      if (window.innerWidth > 420) {
        this.scaleRatio = 1.2
      } else {
        this.scaleRatio = 0.8
      }
    },
    init3D () {
      this.canvas = this.$el.querySelector('canvas') // Get the canvas element
      this.engine = new Engine(this.canvas, true) // Generate the BABYLON 3D engine

      this.scene = this.createScene() // Call the createScene function

      // Register a render loop to repeatedly render the scene
      this.engine.runRenderLoop(() => {
        this.scene.render()
      })
    },
    createScene () {
      var scene = new Scene(this.engine)
      scene.clearColor = new Color4(0, 0, 0, 0.0000000000000001)

      this.camera = new ArcRotateCamera('camera', -Math.PI / 2, Math.PI / 2, this.radius, new Vector3(0, 0.2, 0), scene)

      const light = new HemisphericLight('light', new Vector3(0, 10, 0), scene)
      const light2 = new HemisphericLight('light2', new Vector3(0, 0, 0), scene)
      // var light = new DirectionalLight('light', new Vector3(0, -10, -100), scene)
      light.intensity = 1
      light2.intensity = 1
      light.specular = new Color3(0, 0, 0)
      light2.specular = new Color3(0, 0, 0)

      const webfolder = (this.attributes.webfolder || this.attributes.value) + '/'
      SceneLoader.LoadAssetContainer(webfolder, 'babylon.babylon', scene, (container) => { // onsuccess
        // console.log(container)
        if (!container.meshes.length) return
        // container.addAllToScene()
        // let entries = container.instantiateModelsToScene()
        if (this.slideIndex !== undefined) {
          // scrolly
          scene.removeCamera(this.camera)
          this.camera = [...container.cameras][0]
          scene.activeCamera = this.camera
        } else {
          this.scaleRatio = 0.9 // 0.4
          this.originalPosition.y = 0
          scene.meshes = container.meshes
        }

        this.camera.attachControl(this.canvas, true)
        this.camera.inputs.remove(this.camera.inputs.attached.mousewheel)
        // this.camera.lowerRadiusLimit = 16
        // this.camera.upperRadiusLimit = 42

        container.meshes.forEach((mesh, i) => {
          // considering there are only 2 meshes including the default model and plane camera
          if (mesh.name.toLowerCase() === 'default') {
            this.mesh = [...container.meshes][i]
          } else {
            // this.originalPosition.y = [...container.meshes][i].position._y
            this.originalScale = [...container.meshes][i].scaling._x // 4 / [...container.meshes][i].scaling._x
            if (this.originalScale < container.meshes[i].scaling._y) {
              this.originalScale = [...container.meshes][i].scaling._y
            }
            if (this.originalScale < container.meshes[i].scaling._z) {
              this.originalScale = [...container.meshes][i].scaling._z
            }
          }
        })
        scene.meshes[0] = this.mesh
        var newScale = this.scaleRatio
        if (this.slideIndex !== undefined) {
          newScale = this.originalScale * this.scaleRatio
          var size = this.mesh.getBoundingInfo().boundingBox.extendSize
          if (size._y > 1) {
            this.originalPosition.y = size._y
            this.mesh.position = new Vector3(0, this.originalPosition.y * this.positionYMult, 0)
          }
        } else {
          this.mesh.position = new Vector3(0, 0, 0)
        }
        this.mesh.scaling = new Vector3(newScale, newScale, newScale)

        scene.stopAllAnimations()

        this.builtInAnimations(container, scene)

        hotSpotActions(this.scene)

        setTimeout(() => {
          // container.removeAllFromScene()
          this.showLoading = false
          if (this.slideIndex !== undefined) {
            // stop animation on load
            scene.stopAllAnimations()
          }
        }, 500)
      }, null, (scene, message, err) => {
        console.log('err', err)
      })

      scene.onPointerDown = (evt, pickResult) => {
        this.scene.stopAllAnimations()
        // if (this.initRotateAnimation) {
        //   this.initRotateAnimation.pause()
        // }
        // We try to pick an object
        // if (pickResult.hit) {
        //   console.log('cam', this.camera._position, this.camera._rotation)
        // }
      }

      return scene
    },
    builtInAnimations (container, scene) {
      const newMeshes = container.meshes
      if (newMeshes && newMeshes.length) {
        newMeshes.forEach((newMesh, i) => {
          newMesh.animations.forEach((animation, i) => {
            const meshAnimation = new Animation(`meshAnimation_${animation.targetProperty}`, animation.targetProperty, animation.framePerSecond, animation.dataType, animation.loopMode)
            if (this.frameRanges.from === 0 && this.frameRanges.to === 0) {
              this.frameRanges = {...animation._ranges[Object.keys(animation._ranges)[0]]}
            }
            if (animation.targetProperty === 'rotation') {
              animation._keys.forEach((key) => {
                key.value.x = this.mesh.rotation.x - key.value.x
                key.value.z = this.mesh.rotation.z - key.value.z
                key.value.y = this.mesh.rotation.y - key.value.y
              })
            }
            if (animation.targetProperty === 'scaling') {
              animation._keys.forEach((key) => {
                if (this.slideIndex !== undefined) {
                  key.value.x *= this.scaleRatio
                  key.value.y *= this.scaleRatio
                  key.value.z *= this.scaleRatio
                } else {
                  key.value.x = this.scaleRatio * 2.5
                  key.value.y = this.scaleRatio * 2.5
                  key.value.z = this.scaleRatio * 2.5
                }
              })
            }
            if (animation.targetProperty === 'position') {
              animation._keys.forEach((key) => {
                // key.value.x = this.mesh.position.x
                // key.value.z = this.mesh.position.z
                if (this.slideIndex !== undefined) {
                  key.value.y = this.originalPosition.y * this.positionYMult
                } else {
                  key.value.y *= 0
                }
              })
            }
            meshAnimation.setKeys(animation._keys)
            this.meshAnimationsArr.push(meshAnimation)
          })
        })
      }
      if (container.cameras && container.cameras.length) {
        container.cameras.forEach((camera) => {
          camera.animations.forEach((animation) => {
            const camAnimation = new Animation(`cameraAnimation_${animation.targetProperty}`, animation.targetProperty, animation.framePerSecond, animation.dataType, animation.loopMode)
            // animation._keys.forEach((key) => {
            //   key.value.x = key.value.x * this.radius
            //   key.value.y = key.value.y * this.radius
            //   key.value.z = key.value.z * this.radius
            // })
            camAnimation.setKeys(animation._keys)
            this.camAnimationsArr.push(camAnimation)
          })
        })
        if (this.slideIndex === undefined) {
          // auto play if not scrolly
          scene.beginDirectAnimation(this.mesh, this.meshAnimationsArr, this.frameRanges.from, this.frameRanges.to, false)
          scene.beginDirectAnimation(this.camera, this.camAnimationsArr, this.frameRanges.from, this.frameRanges.to, false)
        } else {
          scene.beginDirectAnimation(this.mesh, this.meshAnimationsArr, this.frameRanges.from, this.frameRanges.from + 0.1, false)
          scene.beginDirectAnimation(this.camera, this.camAnimationsArr, this.frameRanges.from, this.frameRanges.from + 0.1, false)
        }
      }
      // default rotate if no built in animation or not slider
      if (this.slideIndex === undefined && !(newMeshes[1] && newMeshes[1].animations && newMeshes[1].animations.length)) {
        this.initRotateAnimation = Animation.CreateAndStartAnimation('rotateAnim', this.camera, 'alpha', 20, 240, -Math.PI / 2, -Math.PI * 2.5, Animation.ANIMATIONLOOPMODE_CYCLE)
      }
    },
    rotateLeft () {
      rotateLeft(this.mesh)
    },
    rotateRight () {
      rotateRight(this.mesh)
    },
    zoomIn (newTarget = new Vector3(0, 0, 0), newRadius = 15) {
      zoomIn(this.scene, newTarget, newRadius)
    },
    zoomOut (newTarget = new Vector3(0, 0, 0), newRadius = 20) {
      zoomOut(this.scene, newTarget, newRadius)
    },
    xrCamera () {
      xrCamera(this.scene, this.mesh)
    }
  }
}
</script>

<style lang="scss">
  .threedimension {
    height: 80vh;
    position: relative;
    &.isscroly {
      height: 100vh;
    }
    canvas {
      width: 100%;
      height: 100%;
      touch-action: none;
      outline: none;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    }
    .st-loading-container {
      background-color: transparent !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
